/**
 * App-wide theme variables available in styled-components via <ThemeProvider />
 * @see https://styled-components.com/docs/advanced#theming
 */
export default {
    breakpoints: {
        mobileWidth: '560px',
        pageWidth: '1240px',
        tabletNarrowWidth: '768px',
        tabletWidth: '990px',
    },
    colors: {
        beige100: '#fbf6f4',
        beige200: '#e6e2e0',
        black: '#211614',
        blue100: '#0097ba',
        blue200: '#00677f',
        blue300: '#82b7cc',
        blue400: '#e4ebf1',
        blue500: '#e6f5f7',
        brown: '#978781',
        colorDiscoveryOrange: '#f08d27',
        green100: '#91c17b',
        green200: '#eef7f6',
        grey100: '#656565',
        grey200: '#8b8b8b',
        grey300: '#a2a3a5',
        grey400: '#e3e3e3',
        grey500: '#f4f4f4',
        grey600: '#282828',
        grey700: '#ececec',
        grey800: '#c9ccce',
        heroExploreBackground: '#9db3bd',
        heroSearchBackground: '#d9d3cd',
        heroTreasureBackground: '#f7be6f',
        olive: '#65605b',
        purple400: '#552b78',
        purple500: '#3f205a',
        red100: '#ef4c45',
        red200: '#cc2f28',
        red300: '#ef7874',
        red400: '#fff6f6',
        steel: '#595c61',
        teal: '#27b4a5',
        white: '#fff',
        yellow: '#f7bd6f',
        yellow100: '#ffd200',
    },
    typography: {
        fontPrimary: 'HelveticaNeueW01-55Roma',
        fontPrimaryStrong: 'HelveticaNeueW01-65Medi',
        fontSecondary: 'Futura W01 Book',
        fontSecondaryLight: 'Futura W01 Light',
    },
};
